import { useMemo } from 'react'
import { isHiddenCalculationItem } from 'src/domain/calculationItem'
import { selectDenormalizedCalculationDSLsByParams } from 'src/slices/calculationDSLs/calculationDSLsSlice'
import { selectCalculationItemsByParams } from 'src/slices/calculationItems/calculationItemsSlice'
import { useAppSelector } from 'src/store'

type StoreParams = {
  orgCode: string
  storeCode: string
}

type TenantParams = StoreParams & {
  tenantCode: string
}

/**
 * 組織ごとにフィルタリングされた算出項目を取得するカスタムフック
 * 組織ごとの非表示項目を除外して返す
 */
export const useFilteredCalculationItems = (params: StoreParams) => {
  const { orgCode, storeCode } = params
  const calculationItemsRaw = useAppSelector(
    selectCalculationItemsByParams({ orgCode, storeCode })
  )

  return useMemo(() => {
    return calculationItemsRaw?.filter(
      (item) => !isHiddenCalculationItem(orgCode, item.name)
    )
  }, [calculationItemsRaw, orgCode])
}

/**
 * 組織ごとにフィルタリングされたDSLを取得するカスタムフック
 * 組織ごとの非表示項目を除外して返す
 */
export const useFilteredCalculationDSLs = (params: TenantParams) => {
  const { orgCode, storeCode, tenantCode } = params
  const dslsRaw = useAppSelector(
    selectDenormalizedCalculationDSLsByParams({
      orgCode,
      storeCode,
      tenantCode,
    })
  )

  return useMemo(() => {
    return dslsRaw?.filter(
      (dsl) => !isHiddenCalculationItem(orgCode, dsl.calculationItem.name)
    )
  }, [dslsRaw, orgCode])
}
